import { type Context, useContext } from "react"

export function useSafeContext<TValue>(context: Context<TValue>) {
    const value = useContext(context)

    if (value === null) {
        throw new Error(
            `use${context.displayName} should be used inside <${context.displayName}.Provider>.`
        )
    }

    return value
}
